module.exports = __webpack_public_path__ + "media/hero.b77f2d96.jpg";